/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type PaginationResponse from "./PaginationResponse";
import type TestSoilResponse from "./TestSoilResponse";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type ArchiveRequest from "./ArchiveRequest";
import type IdsRequest from "./IdsRequest";
import type IdRequest from "./IdRequest";
import type SoilApiData from "./SoilApiData";
import type FileContentResult from "./FileContentResult";
import type PendingSubmissionQuerySoil from "./PendingSubmissionQuerySoil";
import type ReportDataRequest from "./ReportDataRequest";
import type PrepareSubmissionSoil from "./PrepareSubmissionSoil";
import type SubmissionDataResponse from "./SubmissionDataResponse";
import type DataRequest from "./DataRequest";
import type SubmissionDisplay from "./SubmissionDisplay";
import type Void from "./Void";
import type ManualSoilSubmissionRequest from "./ManualSoilSubmissionRequest";
import type ReportDataResultSoil from "./ReportDataResultSoil";
import type UpdateReportDataRequestSoil from "./UpdateReportDataRequestSoil";

const urls = {
    pagedExcel(request: PaginationRequestSearch): string {
        return queryUrl("/api/soil/pagedexcel", request);
    }
}

export default {
    urls,
    notCompleted(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestSoilResponse>>> {
        return Axios.post("/api/soil/notcompleted", request, defaultConfig);
    },
    archive(request: ArchiveRequest): Promise<AxiosResponse> {
        return Axios.post("/api/soil/archive", request, defaultConfig);
    },
    archiveSoil(request: IdsRequest): Promise<AxiosResponse> {
        return Axios.post("/api/soil/archivesoil", request, defaultConfig);
    },
    delete(request: IdRequest): Promise<AxiosResponse<boolean>> {
        return Axios.post("/api/soil/delete", request, defaultConfig);
    },
    archived(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestSoilResponse>>> {
        return Axios.post("/api/soil/archived", request, defaultConfig);
    },
    completed(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestSoilResponse>>> {
        return Axios.post("/api/soil/completed", request, defaultConfig);
    },
    getSoilResults(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestSoilResponse>>> {
        return Axios.post("/api/soil/getsoilresults", request, defaultConfig);
    },
    getApiData(request: IdRequest): Promise<AxiosResponse<SoilApiData>> {
        return Axios.post("/api/soil/getapidata", request, defaultConfig);
    },
    pagedExcel(request: PaginationRequestSearch): Promise<AxiosResponse<FileContentResult>> {
        return Axios.get(queryUrl("/api/soil/pagedexcel", request), defaultConfig);
    },
    pendingSubmissions(requestSearch: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<PendingSubmissionQuerySoil>>> {
        return Axios.post("/api/soil/pendingsubmissions", requestSearch, defaultConfig);
    },
    submit(request: ReportDataRequest<PrepareSubmissionSoil>): Promise<AxiosResponse<ReportDataRequest<PrepareSubmissionSoil>>> {
        return Axios.post("/api/soil/submit", request, defaultConfig);
    },
    prepareSubmission(request: DataRequest): Promise<AxiosResponse<SubmissionDataResponse<PrepareSubmissionSoil>>> {
        return Axios.post("/api/soil/preparesubmission", request, defaultConfig);
    },
    pagedWaiting(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/soil/pagedwaiting", request, defaultConfig);
    },
    pagedCompleted(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/soil/pagedcompleted", request, defaultConfig);
    },
    pagedArchived(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/soil/pagedarchived", request, defaultConfig);
    },
    pagedResults(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/soil/pagedresults", request, defaultConfig);
    },
    getSampleNumbersForSubmission(submissionId: number): Promise<AxiosResponse<string[]>> {
        return Axios.post("/api/soil/getsamplenumbersforsubmission", submissionId, defaultConfig);
    },
    updateManualSubmission(request: ManualSoilSubmissionRequest): Promise<AxiosResponse<Void>> {
        return Axios.post("/api/soil/updatemanualsubmission", request, defaultConfig);
    },
    updateReportData(reports: UpdateReportDataRequestSoil[]): Promise<AxiosResponse<ReportDataResultSoil[]>> {
        return Axios.post("/api/soil/updatereportdata", reports, defaultConfig);
    }
}
